import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api/axios';
import { AdminPageHeader, AdminTableCard } from './AdminUi';
import './admin.css';

export default function AdminRatings() {
  const [searchParams] = useSearchParams();
  const doctorFilter = searchParams.get('doctor') || searchParams.get('doctor_id') || '';
  const [data, setData] = useState({ total: 0, results: [] });
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('admin/ratings/', {
      params: {
        limit: 100,
        doctor_id: doctorFilter || undefined,
      },
    })
      .then((r) => setData(r.data))
      .catch((e) => toast.error(e.response?.data?.error || 'Failed'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [doctorFilter]);

  const remove = async (id) => {
    if (!window.confirm('Delete this rating?')) return;
    await api.delete(`admin/ratings/${id}/`);
    toast.success('Deleted');
    load();
  };

  return (
    <div>
      <AdminPageHeader
        title="Ratings & Reviews"
        subtitle={`${data.total} total${doctorFilter ? ` · filtered by doctor #${doctorFilter}` : ''}`}
      />

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
      ) : (
        <AdminTableCard>
          <table className="admin-table admin-table-people">
            <thead>
              <tr>
                <th>Patient</th>
                <th>Doctor</th>
                <th>Rating</th>
                <th>Review</th>
                <th>Date</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.results.length === 0 ? (
                <tr><td colSpan={6} className="text-center text-muted py-4">No ratings found</td></tr>
              ) : (
                data.results.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <div className="admin-person-cell">
                        <div className="admin-person-avatar">
                          {r.user_image ? <img src={r.user_image} alt="" /> : (r.user_name || 'U').slice(0, 1).toUpperCase()}
                        </div>
                        <div className="min-w-0">
                          <div className="fw-semibold text-truncate">{r.user_name || 'Patient'}</div>
                          <div className="small text-muted text-truncate">{r.user_email}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      {r.doctor_id ? (
                        <Link to={`/admin/doctors/${r.doctor_id}`} className="fw-semibold text-decoration-none">
                          {r.doctor_name}
                        </Link>
                      ) : (r.doctor_name || '—')}
                    </td>
                    <td>
                      <div className="admin-rating-cell">
                        <span className="star">★</span>
                        <strong>{r.rating}</strong>
                        <span className="text-muted">/5</span>
                      </div>
                    </td>
                    <td className="small" style={{ maxWidth: 280 }}>
                      <div className="text-truncate">{r.review_text || '—'}</div>
                    </td>
                    <td className="small text-muted">
                      {r.created_at ? new Date(r.created_at).toLocaleDateString() : '—'}
                    </td>
                    <td>
                      <div className="admin-row-actions">
                        {r.doctor_id && (
                          <Link
                            to={`/admin/doctors/${r.doctor_id}/reviews`}
                            className="admin-action-btn view"
                            title="Doctor reviews"
                          >
                            <i className="bi bi-chat-left-text" />
                          </Link>
                        )}
                        <button
                          type="button"
                          className="admin-action-btn reject"
                          title="Delete"
                          onClick={() => remove(r.id)}
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </AdminTableCard>
      )}
    </div>
  );
}
